import { PrimaryInfo } from './../util';
import { Group } from "../../models/Group";

export const getSuggestion = (group: Group): PrimaryInfo => {
    return {
        name: group.groupName,
        id: group.id
    };
};
